<template>
  <Accordion id="linkedDocuments" title="DOCUMENTOS VINCULADOS">
    <b-row class="row-padding pb-0">
      <b-col md="4">
        <SelectWithSearch
          label="Número / Modelo / Série"
          labelBusca="number"
          placeholder="Pesquisar..."
          ref="searchLinkedDocument"
          v-model="linkedDocument"
          :options="nfeAndPurchaseCollection"
          :search="searchLinkedDocument"
          :change="changeLinkedDocument"
        >
          <template slot="no-options">Nenhum resultado encontrado</template>
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase;">
              {{ formatLinkedDocument(props) }}
            </div>
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase;">
              {{ formatLinkedDocument(props) }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col md="7">
        <Label>Chave:</Label>
        <Input
          id="docKey"
          v-model="linkedDocument.docKey"
          placeholder="Informe a chave de acesso"
          :mask="[docKeyMask]"
        />
      </b-col>
      <b-col md="1">
        <br />
        <Button
          type="success"
          class="pl-4 pr-4"
          @click="setLinkedDocumentCollection()"
          :disabled="addingLinkedDocument"
        >
          <b-spinner small v-if="addingLinkedDocument"></b-spinner>
          <PlusThick v-else class="mr-0" title="Adicionar" />
        </Button>
      </b-col>
    </b-row>
    <div class="border-bottom m-2 mt-3 mb-3" />
    <b-row
      class="table-list-products row-padding pt-0"
      v-if="linkedDocuments.linkedDocumentCollection.length"
    >
      <b-col class="busca">
        <table class="table">
          <thead>
            <tr>
              <th md="4" lg="2">Número</th>
              <th md="4" lg="2">Modelo</th>
              <th md="4" lg="2">Série</th>
              <th md="4" lg="5">Chave</th>
              <th md="6" lg="1" class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <LinkedDocument
              v-for="(linkedDocument, key) in linkedDocuments.linkedDocumentCollection"
              :id="key"
              :key="key"
              :linkedDocument="linkedDocument"
            />
          </tbody>
        </table>
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import { Accordion } from '@/components';
import { mapState, mapActions } from 'vuex';
import {
  SelectWithSearch,
  Button,
  Label,
  Input,
} from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import PlusThick from 'vue-material-design-icons/PlusThick';
import LinkedDocument from './LinkedDocument';

export default {
  name: 'LinkedDocuments',
  mixins: [FormatMixin],
  components: {
    Accordion,
    SelectWithSearch,
    Button,
    Label,
    Input,
    PlusThick,
    LinkedDocument,
  },
  data() {
    return {
      docKeyMask: '############################################',
      linkedDocument: [],
      addingLinkedDocument: false,
      nfeAndPurchaseCollection: [],
    };
  },
  computed: {
    ...mapState('nfe', ['nfeCollection']),
    ...mapState('purchase', [
      'linkedDocuments',
      'purchaseCollection',
    ]),
  },
  methods: {
    ...mapActions('nfe', ['setNfeCollection']),
    ...mapActions('purchase', [
      'setPurchaseCollection',
      'setNfeAndPurchaseCollection',
    ]),

    formatLinkedDocument(props) {
      return `${props.data.number} / ${props.data.model} / ${props.data.serie || ''}`;
    },
    changeLinkedDocument(selectedLinkedDocument) {
      if (!selectedLinkedDocument) return this.setEmptyLinkedDocument();

      this.linkedDocument = {
        ...selectedLinkedDocument,
      };

      return true;
    },
    async searchLinkedDocument(search) {
      await this.setPurchaseCollection(search);
      await this.setNfeCollection({ search });
      this.nfeAndPurchaseCollection = await this.setNfeAndPurchaseCollection();
    },
    setEmptyLinkedDocument() {
      this.linkedDocument = [];
    },
    toggleAddingLinkedDocumentLoader() {
      this.addingLinkedDocument = !this.addingLinkedDocument;
    },
    async setLinkedDocumentCollection() {
      this.toggleAddingLinkedDocumentLoader();

      const { linkedDocumentCollection } = this.linkedDocuments;

      linkedDocumentCollection.push({
        ...this.linkedDocument,
        edited: false,
        id: undefined,
      });

      this.setEmptyLinkedDocument();
      this.toggleAddingLinkedDocumentLoader();
    },
  },
};
</script>

<style>
.table-list-linkedDocuments {
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
